import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as RemoveIcon } from '@work4all/assets/icons/remove.svg';

import { IconButtonWithTooltip } from '../IconButtonWithTooltip';
import { BaseActionProps } from '../types';

export const Remove: React.FC<BaseActionProps> = (props) => {
  const { t } = useTranslation();
  return (
    <IconButtonWithTooltip
      tooltip={props.disabled ? t('RIGHTS.MISSING') : t('MASK.REMOVE')}
      icon={<RemoveIcon style={{ width: '1.5rem', height: '1.5rem' }} />}
      {...props}
    />
  );
};
